import {
  login,
  logout,
  getRoleMenu,
  getInfo,
  getDomain,
  loginZlj,
} from "@/api/user";
import { getToken, setToken, removeToken } from "@/utils/auth";
import router, { resetRouter } from "@/router";

const getDefaultState = () => {
  return {
    token: getToken(),
    name: "",
    avatar: "",
    roles: [],
    userInfo: "",
    imageUrl: "",
    ossImageUrl: "",
    menuUrl: ""
  };
};

const state = getDefaultState();

const mutations = {
  RESET_STATE: (state) => {
    Object.assign(state, getDefaultState());
  },
  SET_TOKEN: (state, token) => {
    state.token = token;
  },
  SET_NAME: (state, name) => {
    state.name = name;
  },
  SET_AVATAR: (state, avatar) => {
    state.avatar = avatar;
  },
  SET_ROLES: (state, roles) => {
    state.roles = roles;
  },
  SET_Info: (state, userInfo) => {
    state.userInfo = userInfo;
  },
  SET_ImgUrl: (state, imgUrl) => {
    state.imageUrl = imgUrl;
  },
  OSS_ImgUrl: (state, imgUrl) => {
    state.ossImageUrl = imgUrl;
  },
  SET_MenuURL: (state, menu) => {
    state.menuUrl = menu;
  }
};

const actions = {
  //
  loginZlj({ commit }, userInfo) {
    console.log(userInfo);
    const { flag, token } = userInfo;
    return new Promise((resolve, reject) => {
      loginZlj({
        token: token,
        flag: flag,
      })
        .then((response) => {
          const { data } = response;
          localStorage.setItem("userId", data.userInfo.id);
          localStorage.setItem("zhType", 'zhilingji');
          // localStorage.setItem('userInfo', JSON.stringify(data.userInfo))
          commit("SET_TOKEN", data.token);
          // commit("SET_TYPE",'zhilingji')
          setToken(data.token);
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  // user login
  login({ commit }, userInfo) {
    const { username, password, auth_code } = userInfo;
    return new Promise((resolve, reject) => {
      login({
        username: username.trim(),
        password: password,
        auth_code: auth_code,
      })
        .then((response) => {
          const { data } = response;
          localStorage.setItem("userId", data.userInfo.id);
          localStorage.setItem("zhType", 'baguatan');
          // localStorage.setItem('userInfo', JSON.stringify(data.userInfo))
          commit("SET_TOKEN", data.token);
          setToken(data.token);
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  // get user info
  getRoles({ commit, state }) {
    return new Promise((resolve, reject) => {
      getRoleMenu({
        id: localStorage.getItem("userId"),
        auth_type: 3,
      })
        .then((response) => {
          const { data } = response;
          var roles = [];
          if (!data) {
            reject("Verification failed, please Login again.");
          } else {
            data.lists.forEach((item) => {
              roles.push(item.router_url);
            });
          }
          // roles must be a non-empty array
          // if (!roles || roles.length <= 0) {
          //   reject('getInfo: roles must be a non-null array!')
          // }
          commit("SET_ROLES", roles);
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  // get user info
  getInfo({ commit, state }) {
    return new Promise((resolve, reject) => {
      getInfo({
        id: localStorage.getItem("userId"),
        type: 1,
      })
        .then((response) => {
          commit("SET_Info", response.data.info);
          // roles must be a non-empty array
          // if (!roles || roles.length <= 0) {
          //   reject('getInfo: roles must be a non-null array!')
          // }
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  // user logout
  logout({ commit, state }) {
    return new Promise((resolve, reject) => {
      logout({ user_id: localStorage.getItem("userId") })
        .then((res) => {
          console.log(res,'成功过')
          removeToken(); // must remove  token  first
          resetRouter();
           window.localStorage.clear();
          // 状态保持清除后刷新页面
          window.location.reload();
          this.$router.push(`/login`);
          commit("RESET_STATE");
          resolve();
        })
        .catch((error) => {
          console.log(error,'成功过')
          reject(error);
        });
    });
  },
  // user logout
  getUrl({ commit, state }) {
    return new Promise((resolve, reject) => {
      getDomain()
        .then((response) => {
          commit("SET_ImgUrl", response.data.interface_domain);
          commit("OSS_ImgUrl", response.data.resource_domain);
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  // remove token
  resetToken({ commit }) {
    return new Promise((resolve) => {
      removeToken(); // must remove  token  first
      commit("RESET_STATE");
      resolve();
    });
  },
  // user logout
  getMenu({ commit, state }) {
    return new Promise((resolve, reject) => {
      getRoleMenu({
        id: localStorage.getItem("userId"),
        auth_type: 2,
        is_tree: 2,
        ccc: 44,
      })
        .then((response) => {
          const { data } = response;
          var menuUrl = "";
          if (!data) {
            reject("Verification failed, please Login again.");
          } else {
            if (data.lists[0].nodes.length > 0) {
              menuUrl = data.lists[0].nodes[0].url;
            } else {
              menuUrl = data.lists[0].url;
            }
          }
          commit("SET_MenuURL", menuUrl);
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
